import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../services/localStorage/localStorage.service';
import { NavigationService } from '../services/navigation/navigation.service';
@Injectable({
    providedIn: 'root',
})
export class AuthenticatedGuard implements CanActivate {
    constructor(
        private localStorageService: LocalStorageService,
        private navigationService: NavigationService
    ) {}

    canActivate(): boolean {
        if (!this.localStorageService.isAuthenticated()) {
            console.log('User is not authenticated. Redirecting to login page.');
            return true;
        } else {
            console.log('User is authenticated.');
            // Redirect to the login page if not authenticated
            this.navigationService.routeToPath(`/`);
            return false;
        }
    }
}
